<template>
  <g stroke="currentColor" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square"><g transform="translate(-1156.000000, -122.000000)" stroke="currentColor"><g id="lang-switch-selected" transform="translate(1095.000000, 67.000000)"><polyline points="73 55 67.5 61 62 55"/></g></g></g>
</template>
